/* 实名认证接口 */

import axios from 'axios';
export default {
  authPersonInfo (params) { // 实名认证接口
    return axios.get('/mobile/bankAuthApplyController/authPersonInfo.ht', {
      headers: {
        tokenId: params.token,
        Token: params.token
      }
    });
  },

  authPersonSMSCode (params) { // 实名认证发送短信验证码的接口
    return axios.get('/paymentOrders/sendIndentifyCode.ht', {
      headers: {
        tokenId: params.token,
        Token: params.token
      },
      params: {
        customerId: params.customerId,
        proNumber: params.proNumber,
        bankAccount: params.bankAccount,
        bankAccountOwner: params.bankAccountOwner,
        mobile: params.mobile,
        idno: params.idno,
        msgType: params.msgType,
        Token: params.token
      }
    });
  },

  authPersonSignAgreement (params) { // 实名制接口
    return axios.get('/paymentOrders/confirmSign.ht', {
      params: {
        // proNumber: params.proNumber,
        bankAccount: params.bankAccount,
        bankAccountOwner: params.bankAccountOwner,
        idno: params.idno,
        customerId: params.customerId,
        vCode: params.vCode,
        mobile: params.mobile,
        indexCode: params.indexCode,
        Token: params.token,
        idCardFrontId: params.idCardFrontId,
        idCardBackId: params.idCardBackId
      }
    });
  },

  realNameNotify (params) { // 实名认证结果通知
    return axios.post('/paymentOrders/realNameNotify.ht', params);
  },

  getEnterpriseAuthInfo (params) { // 获取企业实名制信息
    return axios.get('/mobile/bankAuthApplyController/authEnterpriseInfoForJL.ht', {
      headers: {
        tokenId: params.token
      }
    });
  },

  saveEnterpriseAuthInfo (params) { // 提交企业实名制
    return axios.get('/mobile/bankAuthApplyController/enterpriseAuth.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        authId: params.authId,
        customerId: params.customerId,
        customerName: params.customerName,
        enterpriseNumber: params.enterpriseNumber,
        enterpriseOfficeAddress: params.enterpriseOfficeAddress,
        enterpriseLegalUser: params.enterpriseLegalUser,
        enterpriseLegalUserPhone: params.enterpriseLegalUserPhone,
        enterpriseLegalIdNo: params.enterpriseLegalIdNo,
        enterpriseOrganizingNumber: params.enterpriseOrganizingNumber,
        enterpriseAgentUser: params.enterpriseAgentUser,
        enterpriseAgentIdNo: params.enterpriseAgentIdNo,
        enterpriseAgentContact: params.enterpriseAgentContact,
        userType: params.userType,
        registrationType: params.registrationType,
        annualInspection: params.annualInspection,
        province: params.province,
        city: params.city,
        enterpriseScale: params.enterpriseScale,
        enterpriseIndustry: params.enterpriseIndustry,
        fileId: params.fileId
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/personalCenter/realNameAuth.js